module.exports = __webpack_public_path__ + "img/2bbabd4.png";